export default __webpack_public_path__ + "static/hero-video-s4-75b229ed7d2c9f411b2aa6a3513131f4.mp4";